import styled from '@emotion/styled';
import { Button, colors, ProximaLogoWithTextBlack, Text } from '@innovationdepartment/proxima-ui';
import type React from 'react';
import ProximaBackground from 'ui/ProximaBackground';

const Container = styled.div`
  background-color: ${colors.white};
  border: 2px solid ${colors.neutral100};
  border-radius: 16px;
  box-shadow: 0px 2px 4px 2px rgba(25, 33, 33, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 0 auto;
  padding: 48px;
  text-align: center;
  width: 640px;
`;

const PaddedProximaLogo = styled(ProximaLogoWithTextBlack)`
  margin: 24px 0px 24px 72px;
`;

type AuthErrorBoxProps = {
  onRetry: () => void;
};

const AuthErrorBox: React.FC<AuthErrorBoxProps> = ({ onRetry }) => (
  <ProximaBackground showBackdrop>
    <PaddedProximaLogo />
    <Container>
      <Text variant="h4">Something went wrong</Text>
      <Text variant="body1">
        We couldn&apos;t verify your session. Check your connection and try again.
      </Text>
      <Button label="Try again" onClick={onRetry} />
    </Container>
  </ProximaBackground>
);

export default AuthErrorBox;
